/// /config/apiConfig.js

const API_BASES = {
  staging: {
    Login: 'https://fe.fedelza.com/Dev/V1/Security/Login',
    Logout: 'https://fe.fedelza.com/Dev/V1/Security/Logout',
    RecoverPassword: 'https://fe.fedelza.com/Dev/V1/Security/Recovery-Password',
    ChangePassword: 'https://fe.fedelza.com/Dev/V1/Security/Change-password',
    RegisterUserApi: 'https://fe.fedelza.com/Dev/V1/Security/RegisterUserApi',
    RegisterUser: 'https://fe.fedelza.com/Dev/V1/Security/Register-user',
    UpdateUser: 'https://fe.fedelza.com/Dev/V1/Security/Update-User',
    DeleteUser: 'https://fe.fedelza.com/Dev/V1/Security/Delete-User',
    GetToken: 'https://fe.fedelza.com/Dev/V1/Security/Get-Token',
    ValidateToken: 'https://fe.fedelza.com/Dev/V1/Security/Validate-Token',
    RefreshToken: 'https://fe.fedelza.com/Dev/V1/Security/Refresh-Token',
    ActivateUser: 'https://fe.fedelza.com/Dev/V1/Security/Activate-User',
    GetUsersByCustomer: 'https://fe.fedelza.com/Dev/V1/Security/Get-Users-By-Customer',
    UploadCertificate: 'https://fe.fedelza.com/Dev/V1/Invoice/Upload-Certificate',
    GetResolutionByCustomer: 'https://fe.fedelza.com/Dev/V1/Invoice/Get-Resolution-By-Customer',
    SaveResolutionByCustomer: 'https://fe.fedelza.com/Dev/V1/Invoice/Save-Resolution-By-Customer',
    ResendEmail: 'https://fe.fedelza.com/Dev/V1/Invoice/Resend-Email',
    GetDocument: 'https://fe.fedelza.com/Dev/V1/Invoice/Get-Document',
    GetInvoicesByCustomer: 'https://fe.fedelza.com/Dev/V1/Invoice/Get-Invoices-By-Customer',
    GetQuantitiesByCustomer: 'https://fe.fedelza.com/Dev/V1/Invoice/Get-Quantities-By-Customer',
    VerifyOtp: 'https://fe.fedelza.com/Dev/V1/Security/Validate-otp'
    
  }
};

// Configuración del entorno actual
const CURRENT_ENV = 'staging';

// Exportar las URLs del entorno actual directamente
const apiConfig = API_BASES[CURRENT_ENV];

export default apiConfig;